'use strict';

module.exports = {
  NotSupportedError: require('./NotSupportedError')
};


// WEBPACK FOOTER //
// ./lib/errors/index.js